<template>
    <v-card :class="{ 'rounded': !isMobile() }">
        <v-layout
                row
                wrap
                pa-2
        >
            <v-flex xs12 md4>
                <v-subheader
                        :key="titleHeader"
                        class="subheading"
                >
                    {{ titleHeader }}
                </v-subheader>
            </v-flex>
            <v-flex xs12 md4 class="pl-3">
                <v-text-field
                        class="pt-1"
                        v-model="search"
                        :append-icon="search?'close':'search'"
                        @click:append="search = ''"
                        label="Search"
                        single-line
                        hide-details
                        @keydown.native.escape="search=''">
                </v-text-field>
            </v-flex>
            <v-flex pl-2 xs12 md4 v-if="showSearchButton">

                <v-layout justify-end>
                    <v-btn v-if="showSearchButton" round
                           depressed
                           color="success"
                           @click="startSearch()"
                    >
                        {{ addNewTitle }}
                        <v-icon right dark>
                            search
                        </v-icon>
                    </v-btn>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-list two-line>
            <template v-for="(element, index) in filteredItems">
                <v-divider
                        v-if="element.divider"
                        :inset="element.inset"
                />
                <v-list-tile class="clickable-cursor"
                             v-else
                             :key="element.id"
                >
                    <v-layout row wrap>
                        <v-flex grow>
                            <v-list-tile-content @click="clickCallback(element)">
                                <v-list-tile-title v-html="element.nameToShow"></v-list-tile-title>
                                <v-list-tile-sub-title v-html="element.description"></v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-flex>
                    </v-layout>
                </v-list-tile>
            </template>
        </v-list>

        <v-dialog
                v-model="showScoreTables"
                max-width="85%"
        >
            <v-card>
                <v-card-title class="headline">How to calculate the score </v-card-title>
                <v-card-text>
                    <ScoreTables></ScoreTables>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    import ScoreTables from "@/pages/Admin/Innovation/StartupManagement/ScoreTables";

    export default {
        name: "List",
        components: {ScoreTables},
        props: {
            elements:{
                type: Array
            },
            titleHeader:{
                type: String
            },
            addNewTitle:{
                type: String
            },
            searchCallback:{
                type: Function
            },
            clickCallback:{
                type: Function
            },
            showSearchButton:{
                type: Boolean,
                default: true
            },
            searchStartup:{
                type:Function
            }
        },
        computed: {
            filteredItems() {
                let filtered = [];
                for (let i=0; i<this.elements.length; i=i+2){
                    if(this.elements[i].nameToShow.toLowerCase()){
                        filtered.push(this.elements[i]);
                        filtered.push(this.elements[i+1]);
                    }
                }
                filtered.pop();
                return filtered;
            }
        },
        data() {
            return {
                showScoreTables: false,
                search: '',
            }
        },
        methods: {
            isMobile() {
                return this.$vuetify.breakpoint.name === "xs";
            },
            startSearch(){
                this.searchStartup(this.search)
            }
        }
    }
</script>

<style scoped>
    .clickable-cursor{
        cursor: pointer;
    }
</style>